export default function useProductOriginDomain() {
  let domain: string = window.location.hostname;

  if (domain === "localhost") {
    domain = "student.mp.localhost";
  }

  return { domain };
}
